<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('api keys')"
      :columns="columns"
      :column_search="true"
      resource_url="/assistant/api-key/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>
  </div>

  <api-key-modal ref="api_key_modal" @success="refresh" />
  <create-api-key-modal ref="create_api_key_modal" @success="refresh" />
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  format_date_time,
  del,
  put,
  error_message,
  input_alert,
  format_currency,
} from "@/utils";
import ApiKeyModal from "./api_key_modal/Index.vue";
import CreateApiKeyModal from "./create_api_key_modal/Index.vue";
import moment from "moment";

export default {
  name: "ApiKeyDatatable",
  components: { GenericTable, ApiKeyModal, CreateApiKeyModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("name"),
          data: (row) => {
            return row.name || "";
          },
        },
        {
          title: v.$t("personality"),
          data: (row) => {
            return row.personality?.name || "";
          },
        },
        {
          title: v.$t("created at"),
          data: (row) => {
            return format_date_time(row.create_date);
          },
        },
        {
          title: v.$t("expires at"),
          data: (row) => {
            return format_date_time(row.expire_date);
          },
        },
        // {
        //   title: v.$t("personality"),
        //   data: (row) => {
        //     return row.personality.name || "";
        //   },
        // },
        // {
        //   title: v.$t("data"),
        //   name: "data",
        //   data: (row) => {
        //     return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //   },
        // },
        {
          title: v.$t("options"),
          width: "20%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("show"),
                icon: "fa fa-eye",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.api_key_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete api key?"),
                    v,
                    () => {
                      del("/assistant/api-key", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    create() {
      let v = this;
      // v.$refs.api_key_modal.show_modal();
      // input_alert({
      //   title: v.$t("enter api key name"),
      //   text: v.$t("this name is for your reference only"),
      //   input: "text",
      // }).then((result) => {
      //   put("/assistant/api-key", {
      //     name: result,
      //   })
      //     .then(() => {
      //       v.refresh();
      //     })
      //     .catch((error) => {
      //       error_message(error);
      //     });
      // });
      v.$refs.create_api_key_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
